export enum PredictionStatusEnum {
    ACTIVE              = 1,
    PROCESSED           = 2,
    PENDING             = 3,

    ARCHIVED            = 10, // reserved
}
